import { ButtonBase } from '../../Button/ButtonBase';

import styles from './BlockInnerTextButton.module.scss';

import type { FC, ReactNode } from 'react';

export type Props = {
  button: 'primary' | 'secondary';
  buttonText: string;
  link: string;
  children?: ReactNode;
};

export const BlockInnerTextButton: FC<Props> = ({
  children,
  link,
  button,
  buttonText,
}) => (
  <div className={styles.wrap}>
    <div className={styles['wrap-contents']}>{children}</div>
    <div className={styles['wrap-button']}>
      <ButtonBase color={button} width="wide" link={link}>
        {buttonText}
      </ButtonBase>
    </div>
  </div>
);
